import { computed, effect, Injectable, OnDestroy } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { FilterBuilder } from '../../../helper/filter.builder';
import config from '../../../../../config/config';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { getUserGroupsFrag, getUsersFrag } from './create-user-dialog.query';
import { UserGridItemObject } from '@it2go/types';
import { GroupUserObject } from '@libs/types/src/user/object-type/group-user.object';

@Injectable()
export class CreateUserDialogStore extends ComponentStoreV2Factory implements OnDestroy {

    public searchUser = new Subject<string>();
    public user = computed<UserGridItemObject>(() => this.data.getUsers()?.items?.[0] || null);
    public groups = computed<GroupUserObject[]>(() => this.data.getGroupUsers()?.items || []);

    private sub?: Subscription;

    constructor() {
        super();
        this.sub = this.searchUser
            .pipe(debounceTime(config.debounceTime))
            .subscribe(async (it) => {
                this.api.getUsers(FilterBuilder.filter({ email: it }), getUsersFrag);
            })
        ;

        effect(() => {
            const user = this.user();
            if (!user) return;

            this.api.getGroupUsers(FilterBuilder.singlePage({
                userId: user.id,
                organizationId: this.globalGlobalStore.organizationStore.selectedId(),
            }), getUserGroupsFrag).then();
        });
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
        this.sub?.unsubscribe();
    }

}
